__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "connect-console-accounts";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "11.2.14", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/http.js */ 65775); }; }, 1);
			register("@angular/common", "11.2.14", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/common.js */ 19387); }; }, 1);
			register("@angular/core", "11.2.14", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js */ 40561); }; }, 1);
			register("@angular/router", "11.2.14", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js */ 9126); }; }, 1);
			register("@mitel/cloudlink-sdk", "0.1.0-alpha.130", function() { return Promise.all([__webpack_require__.e("default-node_modules_rxjs__esm2015_internal_ReplaySubject_js-node_modules_rxjs__esm2015_inter-1b4c36"), __webpack_require__.e("default-node_modules_mitel_cloudlink-sdk_index_js"), __webpack_require__.e("default-node_modules_lodash_lodash_js-node_modules_rxjs__esm2015_internal_observable_fromEven-7db65c")]).then(function() { return function() { return __webpack_require__(/*! ./node_modules/@mitel/cloudlink-sdk/index.js */ 39097); }; }); });
			register("@ngx-translate/core", "13.0.0", function() { return Promise.all([__webpack_require__.e("default-node_modules_rxjs__esm2015_internal_ReplaySubject_js-node_modules_rxjs__esm2015_inter-1b4c36"), __webpack_require__.e("default-node_modules_ngx-translate_core___ivy_ngcc___fesm2015_ngx-translate-core_js"), __webpack_require__.e("common")]).then(function() { return function() { return __webpack_require__(/*! ./node_modules/@ngx-translate/core/__ivy_ngcc__/fesm2015/ngx-translate-core.js */ 65111); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};